@if (user) {
  <header>
    <div class="header-in">

      <div class="logo-box" >
        <img appGGImage [defaultImage]="logo" [src]="storageUrl + user.club_logo" style="width: 60%" alt="logo">
      </div>

      @if (user.club_name) {
        <span class="club-naam-mobiel">
          {{ user.club_name }}
          <!-- Een club die een super-admin opende (clubkiezer, 24-10-2026):
               op de telefoon staat het label hier, onder de clubnaam. -->
          @if (user.viewed_by) {
            <span class="club-naam-beheerder">{{ 'MEEKIJKEN.label' | translate }}</span>
          } @else if (user.impersonated_by) {
            <span class="club-naam-beheerder">{{ 'CLUB_KIEZER.label' | translate }}</span>
          }
        </span>
      }

      <nav>
        <ul class="navbar-nav">
          <!-- Live → Planning → Wedstrijden (tabel) → Video's (kaarten) →
               Afspeellijsten → Spelers → Uploaden (25-09-2026). -->
          <!-- Een speler: zijn eigen profiel vooraan (docs/SPELERSPROFIEL.md). -->
          @if (speler) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/me" routerLinkActive="active">
                <svg-icon src="assets/icons/user.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.me" | translate}}</span>
              </a>
            </li>
          }
          @if (permissions.schedule && permissions.live && heeftCameras()) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/live" routerLinkActive="active">
                <svg-icon src="assets/icons/recorder.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.live" | translate}}</span>
              </a>
            </li>
          }
          @if (permissions.schedule) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/schedules" routerLinkActive="active" data-rondleiding="plannen-menu">
                <svg-icon src="assets/icons/schedule.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.schedule" | translate}}</span>
              </a>
            </li>
          }
          <!-- Wedstrijden en Trainingen in plaats van Video's (eigenaar
               29-09-2026: "matches en training, videos weghalen, dat is beter
               te begrijpen"). De video's staan onder de wedstrijd of training;
               "Niet ingedeeld" en "In behandeling" blijven tabbladen op
               /videos. Zonder het recht op wedstrijden gaat Wedstrijden naar
               de wedstrijdvideo's, zoals Video's deed. -->
          <!-- Een speler heeft alleen zijn profiel (docs/SPELERSPROFIEL.md stap 3):
               met video_show en playlists_show kwam hij hier op de video's en
               playlists van de hele club, die de gateway hem nu niet meer geeft. -->
          @if (!speler && (permissions.match || permissions.video)) {
            <li class="nav-item">
              <a class="nav-link"
                 [routerLink]="permissions.match ? '/matches' : '/videos'"
                 [queryParams]="permissions.match ? null : { soort: 'match' }"
                 [class.active]="isWedstrijdenActief()"
                 data-rondleiding="taggen-menu">
                <!-- Thuis- en uitshirt; voor Training een pion met bal (eigenaar
                     29-09-2026, M2 en T1). -->
                <svg-icon src="assets/icons/match-shirts.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.matches" | translate}}</span>
              </a>
            </li>
          }
          <!-- League (eigenaar 09-10-2026): wie via zijn team in een league
               speelt, ziet de wedstrijden van die league hier apart; onder
               Wedstrijden staan dan alleen de eigen wedstrijden. -->
          @if (permissions.match && heeftLeague()) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/matches/league" [class.active]="isLeagueActief()">
                <svg-icon src="assets/icons/league.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.league" | translate}}</span>
              </a>
            </li>
          }
          @if (!speler && permissions.video) {
            <li class="nav-item">
              <a class="nav-link"
                 routerLink="/videos"
                 [queryParams]="{ soort: 'training' }"
                 [class.active]="isTrainingenActief()">
                <svg-icon src="assets/icons/training-cone.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.trainings" | translate}}</span>
              </a>
            </li>
          }
          @if (!speler && permissions.playlist) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/playlists" routerLinkActive="active" data-rondleiding="playlists-menu">
                <svg-icon src="assets/icons/playlist.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.playlists" | translate}}</span>
              </a>
            </li>
          }
          @if (permissions.players) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/players" routerLinkActive="active">
                <svg-icon src="assets/icons/players.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.players" | translate}}</span>
              </a>
            </li>
          }
          @if (taggingTeam()) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/tagging" routerLinkActive="active">
                <svg-icon src="assets/icons/tag.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.tagging" | translate}}</span>
              </a>
            </li>
          }
          @if (permissions.search) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/search" routerLinkActive="active">
                <svg-icon src="assets/icons/tags-search.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.search" | translate}}</span>
              </a>
            </li>
          }
          @if (permissions.upload) {
            <li class="nav-item">
              <a class="nav-link" routerLink="/upload" routerLinkActive="active" data-rondleiding="upload-menu">
                <svg-icon src="assets/icons/upload.svg"></svg-icon>
                <span class="text">{{"HEADER.nav.upload" | translate}}</span>
              </a>
            </li>
          }
        </ul>
      </nav>

      <!-- Co-coach (variant C, gekozen door de eigenaar): alleen als de
           server zegt dat hij er is (GET /CoCoach/Beschikbaar); anders
           verandert er hier niets. Op de telefoon alleen het icoon. -->
      @if (coCoach.beschikbaar()) {
        <button type="button"
                class="co-coach-knop ms-auto"
                [class.aan]="coCoach.open()"
                [attr.aria-pressed]="coCoach.open()"
                [attr.aria-label]="'CO_COACH.titel' | translate"
                (click)="coCoach.wissel()">
          <svg-icon src="assets/icons/bubble.svg" [svgStyle]="{ 'width.px': 22, 'height.px': 22 }"></svg-icon>
          <span class="co-coach-tekst">{{ 'CO_COACH.titel' | translate }}</span>
        </button>
      }

      @if (supportChat.beschikbaar()) {
        <button type="button"
                class="support-chat-knop ms-auto"
                [class.ms-auto]="!coCoach.beschikbaar()"
                (click)="supportChat.open()"
                [attr.aria-label]="'HEADER.support_chat' | translate"
                [tooltip]="'HEADER.support_chat' | translate"
                container="body"
                placement="bottom">
          <svg-icon src="assets/icons/comment.svg" [svgStyle]="{ 'width.px': 22, 'height.px': 22 }"></svg-icon>
        </button>
      }

      <app-account-dropdown></app-account-dropdown>

    </div>
  </header>
} @else {
  <header class="guest">
    <div class="header-in">
      <div class="logo-box">
        <img [src]="logo"
             style="width: 60%"
             appGGImage
             defaultImage="/assets/images/sport-iq-logo.png"
             alt="logo">

      </div>
    </div>
  </header>
}
